module.exports = __webpack_public_path__ + "img/techEntrepreneur.3cb8b416.webp";